module.exports = __webpack_public_path__ + "img/globe.9a985e6d.svg";